/**
 * Created by rcabr on 6/1/2016.
 */
angular.module('eStories.library.model', [])
    .service('LibraryModel', [
        'WS',
        'PagingModel',
        'ModalsModel',
        'LL',
        '$rootScope',
        function (WS,
                  PagingModel,
                  ModalsModel,
                  LL,
                  $rootScope) {

            this.changeLibraryAudiobookMetadata = (bookChangesObj) => {
                return WS.callServer('library/changeLibraryAudiobookMetadata', bookChangesObj);
            };

            this.deleteLibraryAudiobook = (libraryAudiobookId) => {
                return WS.callServer('library/deleteLibraryAudiobook', {libraryAudiobookId: libraryAudiobookId});
            };

            this.deleteUploadedLibraryAudiobookFiles = (libraryAudiobookId) => {
                return WS.callServer('library/deleteLibraryAudiobookFiles', {libraryAudiobookId: libraryAudiobookId});
            }

            this.getLibraryCountMap = () => {
                return WS.callServer('library/getLibraryCountMap', {});
            };

            this.assignLibraryList = (libraryList) => {
                this.libraryList = libraryList;
            };

            this.getLibraryContent = (paginationObj, status) => {
                const pagination = paginationObj ? paginationObj : PagingModel.preparePagination(1, 40, false, true);
                const getLibraryContentObj = {pagination: pagination};

                if (status) {
                    getLibraryContentObj.status = status;
                }
                return WS.callServer('library/getAudiobookList', getLibraryContentObj);
            };

            this.getWishList = (paginationObj) => {
                var pagination = paginationObj ? paginationObj : PagingModel.preparePagination(1, 40, false, true);
                return WS.callServer('library/getWishList', {pagination: pagination});
            };

            this.getLibraryAudiobook = (libraryAudiobookId) => {
                return WS.callServer('library/getLibraryAudiobook', {libraryAudiobookId: libraryAudiobookId});
            };

            this.checkIfDownloadIsReady = (libraryAudiobookId) => {
                return WS.callServer('library/checkIfDownloadIsReady', {libraryAudiobookId: libraryAudiobookId});
            };

            this.saveAudiobookProgress = (saveProgressObj) => {
                return WS.callServer('library/saveProgress', saveProgressObj);
            };

            this.archiveLibraryAudiobook = (libraryAudiobookId) => {
                return WS.callServer('library/archiveLibraryAudiobook', {libraryAudiobookId});
            };

            this.restoreLibraryAudiobook = (libraryAudiobookId) => {
                return WS.callServer('library/restoreLibraryAudiobook', {libraryAudiobookId});
            };

            this.markFinished = (libraryAudiobook, finished) => {
                var markedFinishedObj = {
                    libraryAudiobookId: libraryAudiobook.id,
                    finished: finished
                };

                var series = libraryAudiobook.audiobook.series;
                var tagObj = {
                    'Yes/No': finished ? 'YES' : 'NO',
                    'Genre': libraryAudiobook.audiobook.genreList.map(val => val.name),
                    'Title': libraryAudiobook.audiobook.title,
                    'Author': libraryAudiobook.audiobook.authorList.map(val => val.name),
                    'Narrator': libraryAudiobook.audiobook.narratorList.map(val => val.name),
                    'Book ID': libraryAudiobook.audiobook.id,
                    'Series': series,
                    'Days from Start': parseInt((new Date() - new Date(libraryAudiobook.creationDate)) / 1000 / 60 / 60)
                };

                LL.tagEvent('Mark Complete ', tagObj);
                return WS.callServer('library/markFinished', markedFinishedObj);
            };

            this.bookmark = {
                position: null,
                time: null,
                note: null,
                chapter: null
            };

            // used to populate Bookmark Modal
            this.bookmarkedAudiobook = null;
            this.bookmarkToEdit = null;

            this.saveBookmark = (position, note, chapterId, libraryAudiobook) => {
                var saveBookmarkObj = {
                    position: position,
                    note: note,
                    chapterId: chapterId,
                    libraryAudiobookId: libraryAudiobook.id

                };

                var llObject = LL.convertAudiobookToLocalyticsObject(libraryAudiobook.audiobook);
                LL.tagSaveBookmark(saveBookmarkObj, "Add", llObject);
                return WS.callServer('library/saveBookmark', saveBookmarkObj);
            };

            this.updateBookmark = (bookmarkToEdit, libraryAudiobook) => {
                var updateBookmarkObj = {bookmarkId: bookmarkToEdit.id, note: bookmarkToEdit.note};
                var llObject = LL.convertAudiobookToLocalyticsObject(libraryAudiobook.audiobook);
                LL.tagSaveBookmark(updateBookmarkObj, "Update", llObject);
                return WS.callServer('library/updateBookmark', updateBookmarkObj);
            };

            this.deleteBookmark = (bookmark) => {
                LL.tagSaveBookmark(bookmark, "Delete", {});
                return WS.callServer('library/deleteBookmark', {bookmarkId: bookmark.id});
            };

            this.openBookmarksModal = (libraryAudiobook) => {
                this.bookmarkedAudiobook = libraryAudiobook;
                ModalsModel.open("/library/bookmarks/bookmarksModal.tmpl.html", "BookmarksCtrl", "bookmarksCtrl");
            };

            this.getShortTime = (position) => {
                return (position / 1000).toString().toShortHHMMSS();
            };

            this.getSectionItemLocation = () => {
                switch ($rootScope.accountModel.userDetails.countryCode) {
                    case 'US':
                        return 'US';
                    case'GB':
                        return 'GB';
                    default:
                        return 'WORLD';
                }

            }

        }])

    .controller('BookmarksCtrl', [
        'LibraryModel',
        '$rootScope',
        '$uibModalInstance',
        function (LibraryModel, $rootScope, $uibModalInstance) {

            var bookmarksCtrl = this;

            bookmarksCtrl.bookmarkedAudiobook = LibraryModel.bookmarkedAudiobook;
            bookmarksCtrl.bookmarkList = LibraryModel.bookmarkedAudiobook.bookmarkList;

            bookmarksCtrl.playFromBookmarkPosition = (libraryAudiobook, bookmark) => {
                var progressObj = libraryAudiobook.progress;
                libraryAudiobook.progress = {
                    chapter: bookmark.chapter,
                    id: progressObj.id,
                    position: bookmark.position
                };
                $uibModalInstance.close();
                $rootScope.$broadcast('playAudiobook', libraryAudiobook);
            };

            bookmarksCtrl.getStringDate = (dateData) => {
                return getStringDate(dateData);
            };

            bookmarksCtrl.getShortTime = (position) => {
                return LibraryModel.getShortTime(position);
            };

            bookmarksCtrl.deleteBookmark = async (bookmark) => {
                const response = await LibraryModel.deleteBookmark(bookmark);
                if (response.responseStatus == 'SUCCESS') {
                    bookmarksCtrl.removeBookmarkFromLocalList(bookmark.id);
                }
            };

            bookmarksCtrl.updateBookmark = async () => {
                var bookmark = bookmarksCtrl.bookmarkToEdit;
                const response = await LibraryModel.updateBookmark(bookmark, bookmarksCtrl.bookmarkedAudiobook);
                if (response.responseStatus == 'SUCCESS') {
                    bookmarksCtrl.updateLocalBookmarkList(response.bookmark);
                    bookmarksCtrl.cancelBookmarkEdit();
                }
            };

            bookmarksCtrl.removeBookmarkFromLocalList = (bookmarkId) => {
                var bookmarkList = bookmarksCtrl.bookmarkList;
                for (var i = 0; i < bookmarkList.length; i++) {
                    if (bookmarkList[i].id == bookmarkId) {
                        bookmarkList.splice(i, 1);
                        break;
                    }
                }
            };

            bookmarksCtrl.updateLocalBookmarkList = (newBookmark) => {
                for (var i = 0; i < bookmarksCtrl.bookmarkList.length; i++) {
                    if (bookmarksCtrl.bookmarkList[i].id == newBookmark.id) {
                        bookmarksCtrl.bookmarkList[i] = newBookmark;
                        break;
                    }
                }
            };

            bookmarksCtrl.editBookmark = (bookmark) => {
                bookmarksCtrl.bookmarkToEdit = bookmark;
                bookmarksCtrl.edit = true;
            };

            bookmarksCtrl.cancelBookmarkEdit = () => {
                bookmarksCtrl.bookmarkToEdit = null;
                bookmarksCtrl.edit = false;
            };


        }]);
